import { createSelector } from 'reselect';

export const getComponentState = state => state.myUthealthEditor;

export const getTemplateCode = createSelector(
    getComponentState,
    (state) => state.templateCode
);
export const getQuantity = createSelector(
    getComponentState,
    (state) => state.variables.quantity
);
export const getItem = createSelector(
    getComponentState,
    (state) => state.item
);
export const getClinics = createSelector(
    getComponentState,
    (state) => state.clinics
);
export const getLocations = createSelector(
    getComponentState,
    (state) => state.locations
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getFetchingClinics = createSelector(
    getComponentState,
    (state) => state.fetchingClinics
);
export const getFetchingLocations = createSelector(
    getComponentState,
    (state) => state.fetchingLocations
);
export const getAddingToCart = createSelector(
    getComponentState,
    (state) => state.addingToCart
);
export const getNotes = createSelector(
    getComponentState,
    (state) => state.variables.notes
);
export const getLanguage = createSelector(
    getComponentState,
    (state) => state.variables.language
);
export const getProduct = createSelector(
    getComponentState,
    (state) => state.variables.product
);
export const getClinicId = createSelector(
    getComponentState,
    (state) => state.variables.clinic_id
);
export const getLocationId = createSelector(
    getComponentState,
    (state) => state.variables.location_id
);
export const getOtherLocation = createSelector(
    getComponentState,
    (state) => state.variables.other_location
);
export const getClinicName = createSelector(
    getComponentState,
    (state) => state.variables.clinic_name
);
export const getYourLocation = createSelector(
    getComponentState,
    (state) => state.variables.your_location
);
export const getIsFavorite = createSelector(
    getComponentState,
    (state) => state.isFavorite
);
export const getAddingFavorite = createSelector(
    getComponentState,
    (state) => state.addingFavorite
);
export const getCheckingFavorite = createSelector(
    getComponentState,
    (state) => state.checkingFavorite
);
export const getSavingWork = createSelector(
    getComponentState,
    (state) => state.savingWork
);
export const getAction = createSelector(
    getComponentState,
    (state) => state.action
);